/* rs-rec-arrows.js - mobile scroll arrows for the "You may also like" slider. snippets/section.product-recommendations.liquid
   loads this file and passes the section id as data-section-id. launch readiness pass 2, 2026-09-24: moved out of the inline <script>;
   loaded with `defer` - it already waits for the async recommendations via MutationObserver, so timing is unchanged. */
(function () {
  if (!window.matchMedia('(max-width: 768px)').matches) return;
  /* section id travels on the loader tag's data-section-id (it was Liquid-interpolated when this was inline) */
  var sid = (document.currentScript && document.currentScript.getAttribute('data-section-id')) || '';
  // Observe the section wrapper (always present) rather than the async
  // <product-recommendations> element, which may not exist yet when this runs.
  var root = document.getElementById('shopify-section-' + sid) || document.body;
  function init() {
    var scope = document.getElementById('Recommendations-' + sid) || root;
    var grids = scope.querySelectorAll('.scrollable-grid--small');
    var scroller = null;
    for (var i = 0; i < grids.length; i++) {
      if (!grids[i].classList.contains('visually-invisible') && grids[i].children.length > 1) { scroller = grids[i]; break; }
    }
    if (!scroller) return false;
    var wrap = scroller.parentElement;
    if (wrap.querySelector('.rs-recarr')) return true;
    wrap.classList.add('rs-recarr-wrap');
    wrap.insertAdjacentHTML(
      'beforeend',
      '<button type="button" class="rs-recarr rs-recarr--left" aria-label="Scroll to previous"><svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/></svg></button>' +
      '<button type="button" class="rs-recarr rs-recarr--right" aria-label="Scroll to more"><svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/></svg></button>'
    );
    var L = wrap.querySelector('.rs-recarr--left');
    var R = wrap.querySelector('.rs-recarr--right');
    function upd() {
      var max = scroller.scrollWidth - scroller.clientWidth;
      L.classList.toggle('is-visible', scroller.scrollLeft > 8);
      R.classList.toggle('is-visible', scroller.scrollLeft < max - 8);
    }
    function page(d) { scroller.scrollBy({ left: d * scroller.clientWidth * 0.8, behavior: 'smooth' }); }
    L.addEventListener('click', function () { page(-1); });
    R.addEventListener('click', function () { page(1); });
    scroller.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd, { passive: true });
    upd();
    return true;
  }
  if (!init()) {
    // Recommendations load async (and lazily, when scrolled into view), so keep
    // observing until the scroller appears — no timeout, or a slow scroll-to
    // could miss the load. Disconnect only once the arrows are wired.
    var mo = new MutationObserver(function () { if (init()) mo.disconnect(); });
    mo.observe(root, { childList: true, subtree: true });
  }
})();
